import React from "react";
import { Helmet } from "react-helmet";

/**
 * Per-page SEO meta. Overrides the global defaults from <HeadMeta /> (App.js)
 * for the page on which it is mounted. Keep titles ~50-60 chars and
 * descriptions ~150-160 chars, with the relevant keywords up front.
 */
export default function Seo({ title, description }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
